import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af37f7b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "edit-user",
  class: "d-flex flex-fill edit-page-40"
}
const _hoisted_2 = { class: "card border-0 background-fb" }
const _hoisted_3 = { class: "edit-header" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "card-body overflow-auto font-size-14" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_9 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_11 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_13 = {
  class: "emailValidation",
  id: "invalidEmail"
}
const _hoisted_14 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_15 = {
  key: 0,
  class: "d-flex flex-column margin-top-10"
}
const _hoisted_16 = { class: "d-flex flex-row justify-content-between align-items-center" }
const _hoisted_17 = { class: "padding-right" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "footer card-footer" }
const _hoisted_20 = { class: "float-left" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "float-right" }
const _hoisted_23 = { class: "loader-div-40" }
const _hoisted_24 = ["src"]

import { computed, ref, onBeforeMount } from "vue";
import {
  ElButton,
  ElInput,
  ElOption,
  ElScrollbar,
  ElSelect,
  ElCheckbox,
} from "element-plus";
import { cloneDeep } from "lodash-es";
import { TYPE } from "vue-toastification";
import { currentRoute, router } from "@/core/router";
import { addUser, editUser, getUserById } from "@/user/services/user.service";
import { getOrganizationList } from "@/organization/services/organization.service";
import { showAlert } from "@/core/popup";
import { authInfo, hasPermission } from "@/core/auth";
import i18n from "@/core/i18n/i18n";
import { getRoleList } from "@/role/services/role.service";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";
import { getOrganizationRoles } from "@/core/auth/user-role";
import { useUserActions } from "@/user/composables/useUserActions";

interface OrganizationRole {
  organizationId: string;
  roleId: string;
  old: boolean;
  oldId?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditUser',
  setup(__props) {

const { sendResetPassword, resetTotpAndNotify } = useUserActions();

const { t } = i18n.global;
const pageName = computed(() =>
  currentRoute.value.name === "createUsers"
    ? t("Common.Create")
    : t("Common.Edit")
);

const organisationList = ref([]);

const roleList = ref([]);

const id = ref("");

const user = ref(defaultUser());

const organizationRoles = ref<OrganizationRole[]>([]);

const mailSent = ref(false);

const responseLoading = ref(false);

const pageLoading = ref(false);

const invalidEmail = ref("");

const isEditing = computed(() => Boolean(id.value));

function defaultUser() {
  return {
    id: "",
    active: "",
    createdAt: undefined,
    updatedAt: undefined,
    name: "",
    username: "",
    lastname: "",
    email: "",
    organizationRoles: [],
    activationId: "",
    activityExpiry: "",
    tenantAdmin: false,
  };
}

const baseFieldsValid = computed(
  () => !!user.value.name && !!user.value.lastname && !!user.value.email
);

function orgRolesComplete() {
  return (
    organizationRoles.value.length > 0 &&
    organizationRoles.value.every((r) => !!r.organizationId && !!r.roleId)
  );
}

const isValid = computed(() => {
  if (user.value.tenantAdmin) return baseFieldsValid.value;
  return baseFieldsValid.value && orgRolesComplete();
});

function addOrganizationToUser() {
  organizationRoles.value.push({
    organizationId: "",
    roleId: "",
    old: false,
  });
}

function removeOrganizationFromUser(index) {
  organizationRoles.value.splice(index, 1);
}

function isSelected(organizationId) {
  const index = organizationRoles.value.findIndex(
    (organizationRole) => organizationRole.organizationId === organizationId
  );
  return index !== -1;
}

function setOrganizationAndRoles(): any {
  const organizationRoleList = [];
  organizationRoles.value.forEach((item) => {
    if (item.organizationId && item.roleId && !item.old) {
      const selectedOrganization = cloneDeep(
        organisationList.value.find(
          (organization) => organization.id === item.organizationId
        )
      );
      const selectedRole = cloneDeep(
        roleList.value.find((role) => role.id === item.roleId)
      );
      if (selectedOrganization && selectedRole) {
        organizationRoleList.push({
          organization: selectedOrganization,
          role: selectedRole,
        });
      }
    } else if (item.organizationId && item.roleId && item.old) {
      const selectedItem = cloneDeep(
        user.value.organizationRoles.find(
          (orgRole) => orgRole.id === item.oldId
        )
      );
      if (selectedItem) {
        selectedItem.role = cloneDeep(
          roleList.value.find((role) => role.id === item.roleId)
        );
        selectedItem.organization = cloneDeep(
          organisationList.value.find(
            (organization) => organization.id === item.organizationId
          )
        );
        organizationRoleList.push(selectedItem);
      }
    }
  });
  return organizationRoleList;
}

function validateEmail(value) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
    invalidEmail.value = "";
    return true;
  }
  invalidEmail.value = t("Auth.EmailVal");
  return false;
}
async function createOrUpdateUser() {
  responseLoading.value = true;
  if (isValid.value && hasPermission("USERS.USER.SAVE")) {
    user.value.organizationRoles = setOrganizationAndRoles();
    user.value.username = user.value.email;
    const isEmailValid = validateEmail(user.value.email);
    if (isEmailValid) {
      if (id.value) {
        await editUser(user.value).then((response) => {
          if (response) {
            showAlert(TYPE.SUCCESS, t("User.UserUpdated"));
            getOrganizationRoles(authInfo.value.userId);
          }
        });
      } else {
        await addUser(user.value).then((response) => {
          if (response) {
            showAlert(TYPE.SUCCESS, t("User.UserCreated"));
            user.value = defaultUser();
          }
        });
      }
    } else {
      showAlert(TYPE.WARNING, t("Auth.EmailVal"));
    }
  } else if (hasPermission("USERS.USER.SAVE")) {
    showAlert(TYPE.WARNING, t("Common.WarningMsg"));
  }
  responseLoading.value = false;
}

async function sendResetPasswordMail() {
  responseLoading.value = true;
  const ok = await sendResetPassword(user.value.email);
  mailSent.value = ok;
  responseLoading.value = false;
}

async function resetTotpClicked() {
  responseLoading.value = true;
  await resetTotpAndNotify(user.value.id, user.value.email);
  responseLoading.value = false;
}

onBeforeMount(async () => {
  pageLoading.value = true;
  await getOrganizationList().then((organisationListDB) => {
    if (organisationListDB) {
      organisationList.value = organisationListDB;
    }
  });

  await getRoleList(null).then((roles) => {
    if (roles) {
      roleList.value = roles;
    }
  });

  id.value = currentRoute.value.params.id as string;
  if (id.value) {
    await getUserById(id.value).then((response) => {
      if (response) {
        user.value = response;
        response.organizationRoles.forEach(async (organizationRole) => {
          // OT-4895: skip orphaned org-roles (deleted org/role -> null) so that
          // opening an affected user's profile doesn't crash the page, which would
          // otherwise make the user impossible to fix through the UI.
          if (!organizationRole.organization || !organizationRole.role) {
            return;
          }
          organizationRoles.value.push({
            organizationId: organizationRole.organization.id,
            roleId: organizationRole.role.id,
            old: true,
            oldId: organizationRole.id,
          });
        });
      }
    });
  }
  pageLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(pageName.value) + " " + _toDisplayString(_unref(t)("Common.User")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", null, [
              _createElementVNode("strong", null, [
                _createTextVNode(_toDisplayString(_unref(t)("Common.Name")), 1),
                _hoisted_8
              ])
            ]),
            _createVNode(_unref(ElInput), {
              "test-id": "user-name",
              id: "user-name",
              modelValue: user.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.name) = $event)),
              size: "small",
              placeholder: _unref(t)('Common.Name')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", null, [
              _createElementVNode("strong", null, [
                _createTextVNode(_toDisplayString(_unref(t)("User.LastName")), 1),
                _hoisted_10
              ])
            ]),
            _createVNode(_unref(ElInput), {
              "test-id": "user-lastname",
              id: "user-lastname",
              modelValue: user.value.lastname,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.lastname) = $event)),
              size: "small",
              placeholder: _unref(t)('User.LastName')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", null, [
              _createElementVNode("strong", null, [
                _createTextVNode(_toDisplayString(_unref(t)("Common.Email")), 1),
                _hoisted_12
              ])
            ]),
            _createVNode(_unref(ElInput), {
              "test-id": "user-email",
              id: "user-email",
              modelValue: user.value.email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.email) = $event)),
              readonly: isEditing.value,
              onKeyup: _cache[3] || (_cache[3] = ($event: any) => (validateEmail(user.value.email))),
              size: "small",
              autocomplete: "off",
              placeholder: _unref(t)('Common.Email')
            }, null, 8, ["modelValue", "readonly", "placeholder"]),
            _createElementVNode("div", _hoisted_13, _toDisplayString(invalidEmail.value), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", null, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("User.TenantAdmin")), 1)
            ]),
            _createVNode(_unref(ElCheckbox), {
              modelValue: user.value.tenantAdmin,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.value.tenantAdmin) = $event)),
              label: _unref(t)('User.TenantAdmin'),
              size: "large"
            }, null, 8, ["modelValue", "label"])
          ]),
          (!user.value.tenantAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Organization")), 1),
                  _createElementVNode("div", null, [
                    _createVNode(_unref(ElButton), {
                      size: "mini",
                      class: "btn-oneTeg",
                      onClick: addOrganizationToUser
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "plus" })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_unref(ElScrollbar), { height: '32vh' }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizationRoles.value, (organization, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "d-flex flex-row justify-content-between margin-top-10",
                        key: index
                      }, [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(ElSelect), {
                            id: "user-organization",
                            "test-id": "user-organization",
                            class: "padding-sm",
                            modelValue: organization.organizationId,
                            "onUpdate:modelValue": ($event: any) => ((organization.organizationId) = $event),
                            size: "small",
                            placeholder: "Select an organization"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organisationList.value, (organization) => {
                                return (_openBlock(), _createBlock(_unref(ElOption), {
                                  key: organization.id,
                                  label: organization.name,
                                  disabled: isSelected(organization.id),
                                  value: organization.id,
                                  id: organization.name
                                }, null, 8, ["label", "disabled", "value", "id"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_unref(ElSelect), {
                            id: "user-role",
                            "test-id": "user-role",
                            modelValue: organization.roleId,
                            "onUpdate:modelValue": ($event: any) => ((organization.roleId) = $event),
                            class: "padding-sm",
                            size: "small",
                            placeholder: "Select a role"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, (role) => {
                                return (_openBlock(), _createBlock(_unref(ElOption), {
                                  id: role.authority,
                                  key: role.id,
                                  label: role.authority,
                                  value: role.id
                                }, null, 8, ["id", "label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("button", {
                            class: "btn btn-link",
                            type: "button",
                            onClick: ($event: any) => (removeOrganizationFromUser(index))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "trash" })
                          ], 8, _hoisted_18)
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          (id.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-link",
                style: {"text-decoration":"none"},
                type: "button",
                disabled: mailSent.value || user.value.activityExpiry,
                onClick: sendResetPasswordMail
              }, _toDisplayString(_unref(t)("Common.ResetPassword")), 9, _hoisted_21))
            : _createCommentVNode("", true),
          (id.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-link",
                style: {"text-decoration":"none"},
                type: "button",
                onClick: resetTotpClicked
              }, _toDisplayString(_unref(t)("Common.ResetTotp")), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_unref(ElButton), {
            class: "btn-oneTeg3",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/users')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("Common.Back")), 1)
            ]),
            _: 1
          }),
          (_unref(hasPermission)('USERS.USER.SAVE'))
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                class: "btn-oneTeg2",
                onClick: createOrUpdateUser
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("Common.Save")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !pageLoading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_23, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_24)
    ], 512), [
      [_vShow, responseLoading.value || pageLoading.value]
    ])
  ]))
}
}

})